import { render, staticRenderFns } from "./MetricsTable.vue?vue&type=template&id=352b5c8c&scoped=true"
import script from "./MetricsTable.vue?vue&type=script&lang=ts"
export * from "./MetricsTable.vue?vue&type=script&lang=ts"
import style0 from "./MetricsTable.vue?vue&type=style&index=0&id=352b5c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b5c8c",
  null
  
)

export default component.exports